module.exports = __webpack_public_path__ + "static/media/pic_friend.abb81381.jpg";